export enum SCREEN_SIZES {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  all = 'all'
}
